import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-azure-wafr-lenses",
  templateUrl: "./azure-wafr-lenses.component.html",
  styleUrls: ["../../azure-wafr-workloads.component.css"],
})
export class AzureWafrLensesComponent {
  @Input() lenses: any[] = [];
  @Output() openLens = new EventEmitter<any>();

  onOpenLens(lens: any) {
    this.openLens.emit(lens);
  }
}
